<template>
  <f7-page :page-content="true">
    <f7-navbar :back-link="$t('atras')">
      <f7-nav-title v-if="id && !readonly" sliding>Editar tipo</f7-nav-title>
      <f7-nav-title v-else-if="id" sliding>Tipo</f7-nav-title>
      <f7-nav-title v-else sliding>Nuevo tipo</f7-nav-title>
      <f7-nav-right>
        <template v-if="readonly">
          <f7-button color="blue" @click="readonly=false">{{$t('common.editar')}}</f7-button>
          <f7-button color="red" @click="deleteItem">{{$t('common.eliminar')}}</f7-button>
        </template>
        <template v-else>
          <f7-button
            v-if="id"
            color="gray"
            class="display-flex margin-right-half"
            @click="cancelarEdicion"
          >Cancelar</f7-button>
          <f7-button
            fill
            icon-f7="floppy_disk"
            text="Guardar"
            class="display-flex"
            @click="$refs.rform.saveItem()"
          ></f7-button>
        </template>
      </f7-nav-right>
    </f7-navbar>

    <r-form
      ref="rform"
      v-slot="{rform}"
      :itemId="id"
      :beforeSave="beforeSave"
      @save="onSave"
      :readonly="readonly"
      :dbAdapter="ItemTipoClasificacion"
      :defaultData="defaultData"
    >
      <f7-card class="padding-vertical-half padding-right">
        <f7-card-header><strong>Cabecera</strong></f7-card-header>
        <f7-card-content>
          <f7-row no-gap class="list list-form no-hairlines">
            <f7-col width="50" medium="33" small="100">
              <r-input outline class="col-100" floating-label label="Código" :form="rform" type="text" name="codigo"></r-input>
            </f7-col>
            <f7-col width="50" medium="33" small="100">
              <r-input
                outline
                class="col-100 naturaleza-input"
                floating-label
                label="Naturaleza por defecto"
                :form="rform"
                type="select"
                name="naturalezaDefault"
                :style="{'--naturaleza-bg': naturalezaColor(rform.formData.naturalezaDefault)}"
              >
                <option value=""></option>
                <option v-for="n in naturalezas" :key="n.valor" :value="n.valor" :style="{backgroundColor: n.bgColor || 'transparent', color: n.color || 'inherit'}">{{ n.valor }} — {{ n.label }}</option>
              </r-input>
            </f7-col>
            <f7-col width="100" medium="33" small="100">
              <r-input
                outline
                class="col-100 color-asociado-input"
                floating-label
                label="Color asociado"
                :form="rform"
                type="select"
                name="colorBadge"
                :style="{'--color-asociado-bg': coloresHex[rform.formData.colorBadge] || 'transparent'}"
              >
                <option v-for="c in colorOptions" :key="c" :value="c" :style="colorOptionStyle(c)">{{ c }}</option>
              </r-input>
            </f7-col>
            <f7-col width="100" medium="33" small="100">
              <r-input outline class="col-100" floating-label label="Denominación" :form="rform" type="text" name="denominacion"></r-input>
            </f7-col>
            <f7-col width="100" medium="33" small="100">
              <r-input outline class="col-100" floating-label label="Reglamento por defecto" :form="rform" type="text" name="reglamentoDefault"></r-input>
            </f7-col>
            <f7-col width="100" medium="33" small="100">
              <r-input outline class="col-100" floating-label label="ITC por defecto" :form="rform" type="text" name="itcDefault"></r-input>
            </f7-col>
          </f7-row>
        </f7-card-content>
        <f7-card-header>
          <strong class="margin-right">Vista previa del badge:</strong>
          <span v-if="rform.formData.codigo" :class="'badge color-' + (rform.formData.colorBadge || 'gray')" style="padding:3px 12px;font-weight:600;">
            {{ rform.formData.codigo }}
          </span>
          <span v-else class="text-color-gray">(sin código)</span>
        </f7-card-header>
      </f7-card>

      <f7-card class="padding-vertical-half padding-right">
        <f7-card-header><strong>Observaciones</strong></f7-card-header>
        <f7-card-content>
          <f7-row no-gap class="list list-form no-hairlines">
            <f7-col width="100">
              <r-input
                outline
                class="col-100 observaciones-input"
                floating-label
                label=""
                :form="rform"
                type="textarea"
                name="observaciones"
                resizable
              ></r-input>
            </f7-col>
          </f7-row>
        </f7-card-content>
      </f7-card>
    </r-form>
  </f7-page>
</template>

<style scoped>
.color-asociado-input ::v-deep select {
  background-color: var(--color-asociado-bg, transparent);
}
.observaciones-input ::v-deep textarea {
  width: 100%;
  box-sizing: border-box;
  min-height: 96px;
}
.naturaleza-input ::v-deep select {
  background-color: var(--naturaleza-bg, transparent);
}
</style>

<script>
import ItemTipoClasificacion from "./../../js/db/ItemTipoClasificacion.js";
import rForm from "./../../components/rForm.vue";
import rInput from "./../../components/rInput.vue";
import NaturalezasMaestro from "./../../js/utils/naturalezasMaestro.js";

export default {
  components: { rForm, rInput },
  props: {
    editable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      ItemTipoClasificacion,
      id: this.$f7route.params.id,
      readonly: !this.editable,
      naturalezas: [],
      naturalezaBgByCode: {},
      colorOptions: [
        'blue','teal','green','orange','red','purple','pink','deeporange','brown','indigo','lime','yellow','deeppurple','lightblue','gray'
      ],
      coloresHex: {
        blue: '#2196f3', teal: '#009688', green: '#4caf50', orange: '#ff9800', red: '#f44336',
        purple: '#9c27b0', pink: '#e91e63', deeporange: '#ff5722', brown: '#795548', indigo: '#3f51b5',
        lime: '#cddc39', yellow: '#ffeb3b', deeppurple: '#673ab7', lightblue: '#03a9f4', gray: '#9e9e9e'
      },
      defaultData: {
        codigo: '',
        denominacion: '',
        naturalezaDefault: 'FIJ',
        reglamentoDefault: '',
        itcDefault: '',
        colorBadge: 'gray',
        observaciones: ''
      }
    };
  },
  mounted() {
    var self = this;
    NaturalezasMaestro.load().then(function (m) {
      self.naturalezas = m.items;
      self.naturalezaBgByCode = m.bgColorByCode;
    });
  },
  methods: {
    colorOptionStyle(c) {
      var bg = this.coloresHex[c] || c;
      var claros = ['lime', 'yellow', 'lightblue', 'gray'];
      var fg = claros.indexOf(c) >= 0 ? '#000' : '#fff';
      return { backgroundColor: bg, color: fg };
    },
    naturalezaColor(nat) {
      // Color de fondo del select Naturaleza desde el configcombo ITEM_NATURALEZAS
      // (metadatos.bgColor). Fuente única para mantener consistencia con listados y badges.
      return this.naturalezaBgByCode[nat] || 'transparent';
    },
    cancelarEdicion() {
      // Descartamos cambios no guardados y volvemos a modo lectura.
      if (this.$refs.rform && typeof this.$refs.rform.cancelEdit === 'function') {
        this.$refs.rform.cancelEdit();
      }
      this.readonly = true;
    },
    beforeSave(data, resolve, reject) {
      if (!data.codigo || !data.codigo.trim()) { this.$f7.dialog.alert('El código es obligatorio.'); return reject(); }
      if (!data.denominacion || !data.denominacion.trim()) { this.$f7.dialog.alert('La denominación es obligatoria.'); return reject(); }
      data.codigo = data.codigo.trim().toUpperCase();
      resolve(data);
    },
    onSave(res) {
      // Si era un alta, navegamos a la vista del item recién creado.
      if (!this.id && res && res.id) {
        this.$f7router.navigate(
          '/itemtipoclasificacion/view/' + encodeURIComponent(res.id) + '/',
          { reloadCurrent: true }
        );
        return;
      }
      // Edición de item existente: nos quedamos aquí, en modo lectura.
      this.readonly = true;
    },
    deleteItem() {
      const self = this;
      self.$f7.dialog.confirm('¿Eliminar este tipo?', () => {
        ItemTipoClasificacion.delete({ itemId: self.id }).then(() => {
          self.$f7router.back();
        }).catch((err) => {
          self.$f7.dialog.alert(typeof err === 'string' ? err : (err.message || 'Error al eliminar.'));
        });
      });
    }
  }
};
</script>
